import React, { useEffect, useState } from "react";
import { Button, Col, List, Modal, Row, Switch } from "antd";
import Loader from "../../../../../../../common/cards/Loader";
import { useDispatch, useSelector } from "react-redux";
import { EditMultiplayerRoundSettings } from "../../../../../../../Config/API/multiplayerSchedule";
import {
  setMatchObj,
  seteventcomplete,
  setroundvariables
} from "../../../../../../../Store/Features/MatchesSlice";
import { error, success } from "../../../../../../../common/Alerts/Message";
import useEventIndexesAndRankPoints from "../../../../../../../common/hooks/useEventIndexesAndRankPoints";
import { InputNumber } from "antd";
import { Form } from "antd";

function ScheduleRounEditModal({ eventId, currentround, open, setopen, getData, roundName }) {
  const eventData = useSelector((state) => state.matches);
  const roundvariables = eventData?.roundvariables;
  const dispatch = useDispatch();

  const currentroundvariables = roundvariables[currentround];
  const [requesting, setrequesting] = useState(false);
  const [killpoints, setkillpoints] = useState();
  const [istrankpoints, setistrankpoints] = useState();
  const [lastrankpoints, setlastrankpoints] = useState();
  const [addManually, setAddManually] = useState(
    currentroundvariables?.individualRankPoints?.length > 0
  );

  const { individualRankPoints: generatedRankPoints } = useEventIndexesAndRankPoints(
    istrankpoints,
    lastrankpoints
  );

  const individualRankPoints = currentroundvariables?.individualRankPoints?.length
    ? currentroundvariables.individualRankPoints
    : generatedRankPoints || [];

  const [eidtIndividualRankPoints, setEidIndividualRankPoints] = useState(individualRankPoints);

  useEffect(() => {
    if (addManually) setEidIndividualRankPoints(individualRankPoints);
    else setEidIndividualRankPoints([]);
  }, [addManually]);

  const handlePointsChange = (value, rank) => {
    setEidIndividualRankPoints((prev) =>
      prev.map((item) => (item.rank === rank ? { ...item, points: value } : item))
    );
  };

  useEffect(() => {
    if (currentroundvariables?.killpoints) {
      setkillpoints(parseInt(currentroundvariables?.killpoints));
      setistrankpoints(parseInt(currentroundvariables?.istrankpoints));
      setlastrankpoints(parseInt(currentroundvariables?.lastrankpoints));
      setEidIndividualRankPoints(currentroundvariables?.individualRankPoints);
    }
  }, [currentroundvariables]);

  useEffect(() => {
    return () => {
      setkillpoints(null);
      setistrankpoints(null);
      setlastrankpoints(null);
      setEidIndividualRankPoints([]);
    };
  }, []);

  const updategroup = async () => {
    try {
      if (isNaN(killpoints) || isNaN(istrankpoints) || isNaN(lastrankpoints)) {
        return error("please enter the points correctly");
      }
      setrequesting(true);

      const object = {
        eventId,
        killpoints: parseInt(killpoints),
        istrankpoints: parseInt(istrankpoints),
        lastrankpoints: parseInt(lastrankpoints),
        individualRankPoints: eidtIndividualRankPoints,
        rankScoring: addManually ? "manual" : "auto"
      };

      const res = await EditMultiplayerRoundSettings(object);
      const data = await res.json();
      if (data.type === "success") {
        dispatch(setMatchObj({ matches: data?.result }));
        dispatch(setroundvariables(data?.result?.roundvariables));
        dispatch(seteventcomplete(data?.result?.complete));
        success("Round updated sucessfully!");
        // get updated data again
        getData();
        setopen(false);
      } else {
        error("couldn't update the group");
      }
      setrequesting(false);
    } catch (e) {
      console.log(e);
      setrequesting(false);
      error("couldn't update the group");
    }
  };

  if (!open) return null;
  const btnstyles = {
    fontWeight: "500",
    fontSize: "larger",
    width: "100%",
    paddingInline: "0",
    minWidth: "unset"
  };
  const Title = () => {
    return <div>{roundName ? `${roundName} Edit` : `Round ${currentround + 1} Edit`}</div>;
  };

  const handleClose = () => {
    setopen(false);
  };

  return (
    <Modal
      title={<Title />}
      className="editPost AddTeamModel"
      confirmLoading
      mask
      maskClosable={false}
      onCancel={handleClose}
      closable={true}
      centered
      destroyOnClose={true}
      visible={open}
      open={open}
      footer={false}
      bodyStyle={{
        padding: "0px 0px 20px 0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
      {requesting ? (
        <Loader smaller noShadow center />
      ) : (
        <Row gutter={[5, 5]} style={{ width: "100%" }}>
          <Col md={24} lg={12}>
            <Row gutter={[5, 5]}>
              <Col span={24} style={{ marginBlock: ".5rem", fontWeight: "500" }}>
                <Row justify="" gutter={[15, 15]}>
                  <div style={{ marginBottom: "10px" }}>
                    <Switch
                      checked={!addManually}
                      onChange={() => setAddManually((prev) => !prev)}
                      checkedChildren="Auto"
                      unCheckedChildren="Manual"
                    />
                  </div>
                  {!addManually && (
                    <>
                      <Col
                        span={24}
                        style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
                        Ist Rank Points
                        <InputNumber
                          type="number"
                          value={istrankpoints}
                          defaultValue={istrankpoints}
                          onChange={(value) => {
                            value = Math.abs(parseInt(value));
                            if (isNaN(value)) value = 0;
                            else if (value === "") {
                              value = 0;
                            }
                            setistrankpoints(parseInt(value));
                          }}
                          className="killsinput"
                        />
                      </Col>
                      <Col
                        span={24}
                        style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
                        <Form.Item
                          label="Last Rank Points"
                          help={
                            lastrankpoints > istrankpoints
                              ? "Last rank points can not be greater than First rank points"
                              : undefined
                          }
                          validateStatus={lastrankpoints > istrankpoints ? "error" : "success"}>
                          <InputNumber
                            type="number"
                            value={lastrankpoints}
                            defaultValue={lastrankpoints}
                            onChange={(value) => {
                              value = Math.abs(parseInt(value));
                              if (isNaN(value)) {
                                value = 0;
                                setlastrankpoints(0);
                              } else if (value === "" || !value) {
                                value = 0;
                                setlastrankpoints(0);
                              } else {
                                setlastrankpoints(parseInt(value));
                              }
                            }}
                            className="killsinput"
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}

                  <Col span={24} style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
                    Kill Points
                    <InputNumber
                      type="number"
                      value={killpoints}
                      defaultValue={killpoints}
                      onChange={(value) => {
                        value = Math.abs(parseInt(value));
                        if (isNaN(value)) value = 0;
                        else if (value === "") {
                          value = 0;
                        }
                        setkillpoints(parseInt(value));
                      }}
                      className="killsinput"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col md={24} lg={12}>
            {!addManually && (
              <List
                size="small"
                header={<h4>Rank based Points Distribution</h4>}
                dataSource={individualRankPoints}
                renderItem={(item) => (
                  <List.Item>
                    <span className="fw-bold">Rank {item?.rank} </span>:{item?.points}
                  </List.Item>
                )}
              />
            )}{" "}
            {addManually && (
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "0.8rem",
                  marginTop: "10px",
                  position: "relative"
                }}
                className="">
                <div style={{ maxWidth: "400px" }}>
                  <Row
                    justify="space-between"
                    align="middle"
                    style={{
                      marginBottom: 10,
                      borderBottom: "1px solid black",
                      fontWeight: "600"
                    }}>
                    <Col style={{ textAlign: "left" }}>Ranks</Col>
                    <Col style={{ textAlign: "center" }}>Points</Col>
                  </Row>
                  <List
                    size="small"
                    dataSource={eidtIndividualRankPoints}
                    renderItem={(item) => (
                      <List.Item style={{ padding: 0, columnGap: "5rem" }}>
                        <span className="fw-bold">Rank {item?.rank} </span>
                        <Form.Item style={{ marginBottom: "5px" }}>
                          <InputNumber
                            min={0}
                            value={item.points}
                            onChange={(value) => handlePointsChange(value, item.rank)}
                            className="killsinput"
                          />
                        </Form.Item>
                      </List.Item>
                    )}
                  />
                </div>
              </div>
            )}
          </Col>

          <Col span={24} className="editbutton">
            <Button
              style={btnstyles}
              loading={requesting ? true : false}
              onClick={() => {
                updategroup();
              }}
              className="btnMobileDimensions"
              type="primary"
              disabled={lastrankpoints > istrankpoints}>
              Update Round
            </Button>
            <Button
              style={btnstyles}
              loading={requesting ? true : false}
              onClick={handleClose}
              className="btnMobileDimensions mt-2"
              type="ghost"
              disabled={requesting}>
              Close
            </Button>
          </Col>
        </Row>
      )}
    </Modal>
  );
}

export default ScheduleRounEditModal;
